import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('programas'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`programas/${id}`));
  },
  async update(id, datos) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`programas/${id}`), datos);
  },
  async gestiones() {
    return await axiosIns.get(obtenerUrlAPIPagos('programas/gestiones'));
  },
  async findAllInscripcionesProgramaUniversidad(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`programas/${id}/inscripciones-programa-universidad`), {
      params: opciones.params,
    });
  },
  async findProgramasConCantidadInscripcionesUniversidad(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('programas/cantidad-inscritos-universidad'), {
      params: opciones.params,
    });
  },
};
